__turbopack_context__.v({
  "dark": "kPjica_dark",
  "light": "kPjica_light",
  "link": "kPjica_link",
  "social-media": "kPjica_social-media",
});
